import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserBankPayAccountValidateInvalidate = http.patch(
  createMockEndpoint('/wallet_user/:walletUserId/bankpay_account/:valid'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
